export const DropDownType = {
  DEFAULT: 'default',
  SWITCH: 'switch'
};
